<template>
  <i class="iconfont pointer" @click="isLogout = true">&#xe69d;</i>
  <el-dialog v-model="isLogout" title="退出登录" width="400px" append-to-body>
    <span>确定退出登录吗？</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="isLogout = false">取消</el-button>
        <el-button type="primary" @click="onClick">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { logout } from "@/hooks/login/useLogin";
import { ref } from "vue";

let isLogout = ref(false);
const onClick = () => {
  logout();
};
</script>
